import { useState } from 'react';
import { EditorLeftSideBarTab } from 'types';

const useLeftSideBar = () => {
  const [selectedTab, setSelectedTab] = useState<EditorLeftSideBarTab>('data');
  const [keyword, setKeyword] = useState('');
  const [isMenuHide, setIsMenuHide] = useState(false);

  const lowerKeyword = keyword.toLowerCase();

  const handleKeywordChange = (event: React.FormEvent<HTMLInputElement>) => {
    const {
      currentTarget: { value },
    } = event;

    setKeyword(value);
  };

  const handleTabClick = (newTab: EditorLeftSideBarTab) => {
    setSelectedTab(newTab);
    setIsMenuHide(false);
  };

  const handleMenuHideButtonClick = () => {
    setIsMenuHide((prev) => !prev);
  };

  return {
    selectedTab,
    keyword,
    isMenuHide,
    lowerKeyword,
    onKeywordChange: handleKeywordChange,
    onTabClick: handleTabClick,
    onMenuHideButtonClick: handleMenuHideButtonClick,
  };
};

export default useLeftSideBar;
